/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsList } from "../../funcs/llmModelsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListModelsRequest$inboundSchema,
};

export const tool$llmModelsList: ToolDefinition<typeof args> = {
  name: "llm-models-list",
  description: `List available models

Lists the currently available models. Provides basic information about each model including its ID and owner.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
